import { Claim } from "../types/claim";

// Move claim-related mock data here
export const mockClaims: Claim[] = [
  {
    id: 1,
    date: "2024-03-15",
    patient: "John Smith",
    patientId: "PT100234",
    services: [
      {
        procedure: "Root Canal",
        procedureCode: "D3310",
        amount: 1200,
        date: "2024-03-15",
      },
      {
        procedure: "Post and Core",
        procedureCode: "D2954",
        amount: 400,
        date: "2024-03-15",
      },
    ],
    totalAmount: 1600,
    status: {
      code: "A4-0",
      desc: "Paid",
    },
  },
  {
    id: 2,
    date: "2024-03-14",
    patient: "Sarah Johnson",
    patientId: "PT100456",
    services: [
      {
        procedure: "Comprehensive Oral Evaluation",
        procedureCode: "D0150",
        amount: 85,
        date: "2024-03-14",
      },
      {
        procedure: "Cleaning",
        procedureCode: "D1110",
        amount: 150,
        date: "2024-03-14",
      },
      {
        procedure: "Full Mouth X-rays",
        procedureCode: "D0210",
        amount: 125,
        date: "2024-03-14",
      },
    ],
    totalAmount: 360,
    status: {
      code: "A4-1",
      desc: "Denied",
    },
  },
  {
    id: 3,
    date: "2024-03-13",
    patient: "Mike Wilson",
    patientId: "PT100789",
    services: [
      {
        procedure: "Crown",
        procedureCode: "D2392",
        amount: 950,
        date: "2024-03-13",
      },
      {
        procedure: "Build-up",
        procedureCode: "D2950",
        amount: 250,
        date: "2024-03-13",
      },
    ],
    totalAmount: 1200,
    status: {
      code: "A3",
      desc: "Rejected - Missing Info",
    },
  },
  {
    id: 4,
    date: "2024-03-12",
    patient: "Emily Davis",
    patientId: "PT100567",
    services: [
      {
        procedure: "Filling - Two Surfaces",
        procedureCode: "D2392",
        amount: 200,
        date: "2024-03-12",
      },
    ],
    totalAmount: 200,
    status: {
      code: "A2",
      desc: "Pending Review",
    },
  },
  {
    id: 5,
    date: "2024-03-11",
    patient: "Robert Brown",
    patientId: "PT100890",
    services: [
      {
        procedure: "Extraction",
        procedureCode: "D7140",
        amount: 300,
        date: "2024-03-11",
      },
      {
        procedure: "Surgical Extraction",
        procedureCode: "D7210",
        amount: 450,
        date: "2024-03-11",
      },
    ],
    totalAmount: 750,
    status: {
      code: "A1",
      desc: "In Process",
    },
  },
];
